import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { Store } from '@ngrx/store';
import { SporitelnaService } from '../../../../service/sporitelna.service';
import {
    SporitelnaBankAccountObject,
} from '@libs/types/src/chcrm/object-type/sporitelna/sporitelna-bank-account.object';
import { OrganizationSettingTypeEnum } from '@libs/types/src/organization/enum/organization-setting-type.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
    OrganizationSettingsCollectionCategoryType,
} from '@libs/types/src/organization/types/organization-settings/organization-settings-collection-category.type';
import {
    OrganizationSettingsDonationFormType,
} from '@libs/types/src/organization/types/organization-settings/organization-settings-donation-form.type';
import { isIntegrationActive, selectActiveIntegration } from '../../../../store/organization/organization.selectors';
import { OrganizationService } from '../../../../../../services/organization.service';

interface State {
    banks: SporitelnaBankAccountObject[];
}

const defaultState: State = {
    banks: [],
};

@Injectable()
export class OrganizationSettingsStore extends ComponentStoreFactory<State, OrganizationService & SporitelnaService> {
    isIntegrationActive$ = {} as Record<
        OrganizationSettingTypeEnum,
        Observable<boolean>
    >;
    integrationData$ = {} as Record<
        OrganizationSettingTypeEnum,
        Observable<{ data: string }>
    >;
    categories$;
    donationForms$;

    private readonly sporitelnaSvc = inject(SporitelnaService);
    private readonly store = inject(Store);

    constructor() {
        super(defaultState, inject(Store), inject(OrganizationService));
        this.addApi(this.sporitelnaSvc);
        Object.values(OrganizationSettingTypeEnum).forEach((it) => {
            this.isIntegrationActive$[it] = this.store.select(
                isIntegrationActive(it),
            );
        });
        Object.values(OrganizationSettingTypeEnum).forEach((it) => {
            this.integrationData$[it] = this.store.select(
                selectActiveIntegration(it),
            );
        });
        this.categories$ = this.integrationData$.collectionCategory.pipe(
            map((it) => {
                const data = JSON.parse(
                    it.data,
                ) as OrganizationSettingsCollectionCategoryType;
                return data.categories;
            }),
        );
        this.donationForms$ = this.integrationData$.donationForm.pipe(
            map((it) => {
                if (!it) return null;
                const data = JSON.parse(
                    it.data,
                ) as OrganizationSettingsDonationFormType;
                return data.forms;
            }),
        );
    }
}
